import { HowToPlaySceneBase } from "src/games/shared/scenes/HowToPlaySceneBase";
import { Games } from "src/constants/Games";
// import { MainScene } from "./MainScene";
// import { GameIntroScene } from "./GameIntro";
import { GameState } from "../objects/GameState";
import { Helpers } from "../objects/Helpers";

export class HowToPlayScene extends HowToPlaySceneBase {
    constructor() {
        super();

        /** JB: Note
         * This game was designed VERY early in this product's life and, as such,
         *  exceptions like this need to be accounted for in the new base class system.
         */
        GameState.current = new GameState();
        var nextSceneObject = Helpers.getNextScene(0);
        GameState.current.sceneNumber = 1;

        this.gameRef = Games.Diagnosis;
        this.mainScene = nextSceneObject;
        this.gameObjectiveTextKey = "Diagnosis.Phaser.HowToPlay.objectiveText";
        this.howToPlayOnComputerTextKey = "Diagnosis.Phaser.HowToPlay.computerInstructions";
        this.howToPlayOnTabletTextKey = "Diagnosis.Phaser.HowToPlay.tabletInstructions";
    }

    preload() {
        this.load.image("pixel", require("/src/assets/qci/sprites/pixel.png"));
        this.load.tilemapTiledJSON('outro-map', require("/src/assets/qci/maps/outro_scene.json"));
        // Loading only the needed terrain
        this.load.image('terrain', require("/src/assets/qci/backgrounds/terrains/i.png"));
        // Load the NPC
        // JB: I wanted this to be offset for grades next to each other, so 1R would be different from 2R, like an offset matrix
        let mustard = (this.gameRef.grade.level + this.gameRef.planet.order) % 3; // 3 is how many aliens we have
        switch (mustard) {
            case 0:
                this.load.image("npc", require("/src/assets/qci/sprites/aliens/sleb-normal.png"));
                break;
            case 1:
                this.load.image("npc", require("/src/assets/qci/sprites/aliens/squeelo-normal.png"));
                break;
            case 2:
            default:
                this.load.image("npc", require("/src/assets/qci/sprites/aliens/snib-normal.png"));
                break;
        }

        // Load all assets here, then reference them in every subsequent scene for free!
        this.load.atlas("assets", require("src/assets/qci/atlas/gameLabDiagnosis.png"), require("src/assets/qci/atlas/gameLabDiagnosis.json"));
        this.load.image("background", require("/src/assets/qci/backgrounds/labDiagnosis_bg.jpg"));

        super.preload();
    }
}



// WEBPACK FOOTER //
// ./src/games/DiagnosisGame/scenes/MainScene.ts